// /**
//  * TypeScript interface for license system objects
//  */
// interface LicenseSystemItemFromBackend {
//     location: string | null;
//     cpId: string | null;
//     licenseSystemId: string;
//     isHub: boolean;
//     isOnline: boolean;
//     onlineStatusChangeTimestamp: string | null;
//     isLicensed: boolean;
//     computerName: string | null;
//     version: string | null;
//     lastChangeDate: string; // currently not used 
// }


export const mapLicenseSystemsToSitesListProps = (licenseSystems) =>
    licenseSystems.map((ls) => {
        // NOTE: to migration
        //        => customers: [] we do not have
        //        => flowLicensed: we get from token/user
        //        => role: we get from token/user
        return {
            alias: ls.location || undefined,
            cpId: ls.cpId || undefined,
            dongleId: ls.licenseSystemId,
            isHub: ls.isHub,
            isOnline: ls.isOnline,
            lastSeen: ls.isOnline
                ? Date.now()
                : ls.onlineStatusChangeTimestamp
                    ? new Date(ls.onlineStatusChangeTimestamp).getTime()
                    : null,
            licensed: ls.isLicensed,
            site: ls.computerName || undefined,
            version: ls.version || undefined,
        };
    });

export const handleSitesChange = (customerPairInfo) => {
    let sites = [];

    try {
        customerPairInfo.forEach((value) => {
            let site = {
                site: value.site || value.dongleId, // If the site is not set, use the dongleId instead.
                licensed: value.licensed,
                dongleId: value.dongleId,
                lastSeen: Number(value.lastSeen),
                alias: value.alias || undefined,
                isHub: value.isHub,
                cpId: value.cpId || undefined,
                version: value.version || undefined,
                role: value.role || undefined,
                customers: value.customers || undefined,
                flowLicensed: value.flowLicensed || undefined, // it is not used anymore but we keep it for backward compatibility
            };

            if (Object.prototype.hasOwnProperty.call(value, 'isOnline') && value.isOnline != null) {
                site.isOnline = value.isOnline;
            }

            if (!sites.some((el) => el.site === site.site && el.dongleId === site.dongleId)) sites.push(site);
        });
    } catch (error) {
        console.log(error);
    }

    return sites;
};

export const handleFlowsChange = (listFlows) => {
    return listFlows.map((flow) => {
        return {
            id: flow.id,
            hub: flow.hubId,
            name: flow.name,
            customerId: flow.customerId,
            created: flow.created,
            clients: flow.clients,
            wfId: flow.targetHfwfId,
            wfName: flow.targetWfName,
        };
    });
};

export const handleSiteUpdate = (sites, updatedSites) => {
    return sites.map((site) => {
        const newSite = updatedSites.find((us) => us.dongleId === site.dongleId);
        if (!newSite) return site;

        if (Object.prototype.hasOwnProperty.call(newSite, 'isOnline') && newSite.isOnline != null) {
            site.isOnline = newSite.isOnline;
        }

        if (Object.prototype.hasOwnProperty.call(newSite, 'isOnline') && newSite.isOnline != null && newSite.isOnline) {
            site.lastSeen = new Date().getTime(); // Here somehow a comma within the timestamp is sent...
        } else site.lastSeen = sanitizeLastSeen(newSite.lastSeen);

        if (!newSite.site) {
            // Support old schema, use the dongleId as site.
            site.site = newSite.dongleId;
        }

        return site;
    });
};

export const handleFlowUpdate = (allflows) => {
    //TODO: complete implementation
    let flows = structuredClone(allflows);
    return flows;
};

export const augmentFlowsWithSiteData = (flows, sites) => {
    let augmentedFlows = [];

    if (flows && sites) {
        // Filter a cpId => siteName object from the sites object

        let cpIdToSiteName = {};

        for (let site of sites) {
            cpIdToSiteName[site.cpId] = site.alias ? site.alias : site.site;
        }

        for (let flow of flows) {
            if (Object.prototype.hasOwnProperty.call(cpIdToSiteName, flow.hub)) {
                flow.hubName = cpIdToSiteName[flow.hub];
            }
            if (flow.clients && flow.clients.length > 0) {
                flow.clientsWithName = [];

                for (let clientCpId of flow.clients) {
                    flow.clientsWithName.push({
                        cpId: clientCpId,
                        name: cpIdToSiteName[clientCpId],
                    });
                }
            }
            augmentedFlows.push(flow);
        }

        return augmentedFlows;
    }

    return flows.slice();
};

const sanitizeLastSeen = (lastSeen) => {
    if (!lastSeen) {
        return null;
    }

    let s1 = lastSeen.split(',')[0];
    return s1.split('.')[0];
};
